import type { MaybeRef } from '@vueuse/shared'

export class ValidationState {
  static get props() {
    return {
      state: {
        type: Boolean,
        default: null,
        required: false
      }
    }
  }
  static use(state: MaybeRef<boolean | null>) {
    function getStateClass(s: boolean | null) {
      return s === true ? 'is-valid' : s === false ? 'is-invalid' : null
    }

    const stateClass = computed(() => getStateClass(unref(state)))

    return { stateClass }
  }
}
